import { Component, createRef } from 'preact';
import PropTypes from 'prop-types';
import { autoServiceApiV2 } from '../../../../services/autoServiceApiV2';
import CustomSelect from '../../../CustomSelect';
import { FormButtons } from '../../components/FormButtons';

export class ChooseModel extends Component {
  constructor(props) {
    super(props);

    this.firstRender = createRef();
    this.firstRender.current = true;

    this.state = {
      modelOptions: [],
      versionOptions: [],
    };

    this.handleSelectModel = this.handleSelectModel.bind(this);
    this.handleSelectVersion = this.handleSelectVersion.bind(this);
    this.getQueryParam = this.getQueryParam.bind(this);
    this.setQueryParam = this.setQueryParam.bind(this);
    this.fetchModels = this.fetchModels.bind(this);
    this.fetchVersions = this.fetchVersions.bind(this);
  }

  componentDidMount() {
    this.fetchModels();
  }

  handleSelectModel(modelId) {
    if (!modelId) return;

    const { setTestDriveData } = this.props;
    const { modelOptions } = this.state;

    const selectedModel = modelOptions.find(
      modelOption => modelOption.id === modelId,
    );

    const testDriveData = {
      modelId,
      modelName: selectedModel.label,
      image: null,
    };

    if (!this.firstRender.current) {
      testDriveData.versionId = undefined;
    }
    this.firstRender.current = false;

    setTestDriveData(testDriveData);
    this.fetchVersions(modelId);

    // updating url params
    const prevSlug = this.getQueryParam('modelo');
    const modelHasChanged = selectedModel.slug !== prevSlug;

    if (selectedModel && modelHasChanged) {
      this.setQueryParam('modelo', selectedModel.slug);
      this.setQueryParam('versao', '');
      this.setState({
        versionOptions: [],
      });
    }
  }

  handleSelectVersion(versionId) {
    if (!versionId) return;

    const { setTestDriveData } = this.props;
    const { versionOptions } = this.state;

    const selectedVersion = versionOptions.find(
      option => option.id === versionId,
    );

    setTestDriveData({
      versionId,
      versionName: selectedVersion.label,
      versionSlug: selectedVersion.slug,
      image: selectedVersion.image,
    });

    // updating url params
    if (selectedVersion) {
      this.setQueryParam('versao', selectedVersion.slug);
    }
  }

  getQueryParam(paramName) {
    const urlString = window.location.search;
    const urlParams = new URLSearchParams(urlString);
    return urlParams.get(paramName);
  }

  setQueryParam(name, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(name, value);
    window.history.pushState({}, '', url);
  }

  async fetchModels() {
    const { setTestDriveData, modelId } = this.props;
    const requestParams = [{ active: true }, { sort: 'ordination,id' }];
    const result = await autoServiceApiV2.getClones(requestParams);

    const modelOptions = result.entries.map(item => ({
      id: item.id.toString(),
      value: item.id.toString(),
      label: item.name,
      slug: item.slug,
    }));

    this.setState({
      modelOptions,
    });

    const initialModel = this.getQueryParam('modelo');

    if (initialModel && !modelId) {
      const model = modelOptions.find(option => option.slug === initialModel);

      if (model)
        setTestDriveData({
          modelId: model.id,
        });
    }
  }

  async fetchVersions(modelId) {
    const { setTestDriveData, versionId } = this.props;
    const result = await window.service.getNewModelDetails(modelId);

    const versionOptions = result.entries.map(version => ({
      id: version.id.toString(),
      value: version.id.toString(),
      label: version.name,
      image: version.profile_image.profile_image.model_main.url,
      slug: version.slug,
    }));

    this.setState({
      versionOptions,
    });

    const initialVersion = this.getQueryParam('versao');

    if (initialVersion && !versionId) {
      const version = versionOptions.find(
        option => option.slug === initialVersion,
      );

      if (version)
        setTestDriveData({
          versionId: version.id,
        });
    }
  }

  render() {
    const { modelId, versionId, image, prevStep, nextStep } = this.props;
    const { modelOptions, versionOptions } = this.state;
    const nextButtonDisabled = !modelId || !versionId;

    return (
      <form>
        <header className="titles-container">
          <h2 className="test-drive__title">Escolha um modelo</h2>
          <p className="test-drive__subtitle">
            Escolha o Citroën que mais combina com você
          </p>
        </header>

        <section className="choose-vehicle-selects">
          <div className="choose-vehicle-select">
            <label className="test-drive__label">Modelo</label>
            <CustomSelect
              handleSelectChange={({ target }) =>
                this.handleSelectModel(target.value)
              }
              name="model"
              options={modelOptions}
              value={modelId}
              placeholderValue="Selecione um modelo"
              searchEnabled={false}
            />
          </div>

          <div className="choose-vehicle-select">
            <label className="test-drive__label">Versão</label>
            <CustomSelect
              handleSelectChange={({ target }) =>
                this.handleSelectVersion(target.value)
              }
              name="version"
              options={versionOptions}
              value={versionId}
              placeholderValue="Selecione uma versão"
              searchEnabled={false}
            />
          </div>
        </section>

        <section className="choose-vehicle-img">
          {image ? (
            <img
              src={image}
              alt=""
              className="choose-vehicle-img__img"
              height={374}
              width={533}
            />
          ) : (
            <div className="choose-vehicle-img__placeholder">
              <span className="choose-vehicle-img__placeholder-text">
                Selecione um modelo para continuar
              </span>
            </div>
          )}
        </section>

        <FormButtons
          prevButtonDisabled
          nextButtonDisabled={nextButtonDisabled}
          {...{ prevStep, nextStep }}
        />
      </form>
    );
  }
}

ChooseModel.propTypes = {
  setTestDriveData: PropTypes.func,
  prevStep: PropTypes.func,
  nextStep: PropTypes.func,
  modelId: PropTypes.string,
  versionId: PropTypes.string,
  image: PropTypes.string,
};
